export const categories = [
  { id: 'rexue', name: '热血', slug: 'rexue', icon: 'ri-fire-line', description: '燃爆全场的战斗番，让你热血沸腾！' },
  { id: 'lianai', name: '恋爱', slug: 'lianai', icon: 'ri-heart-line', description: '甜蜜浪漫的青春恋爱物语' },
  { id: 'xuanyi', name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', description: '烧脑推理，层层反转' },
  { id: 'qihuan', name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line', description: '异世界冒险，无限想象' },
  { id: 'gaoxiao', name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', description: '笑到停不下来的欢乐番剧' },
  { id: 'richang', name: '日常', slug: 'richang', icon: 'ri-sun-line', description: '温馨治愈的日常生活' },
  { id: 'jizhan', name: '机战', slug: 'jizhan', icon: 'ri-rocket-line', description: '机甲对战，硬核科幻' },
  { id: 'kongbu', name: '恐怖', slug: 'kongbu', icon: 'ri-ghost-line', description: '胆量挑战，惊悚刺激' },
];

export const animeList = [
  {
    id: 1,
    title: '鬼灭之刃 柱训练篇',
    slug: 'guimie-zhi-ren-zhu-xunlian-pian',
    category: 'rexue',
    rating: 9.7,
    views: '1.2亿',
    episodes: '11集全',
    status: '已完结',
    year: 2024,
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20anime%20style%20illustration%20of%20a%20young%20swordsman%20with%20dark%20red%20hair%20and%20a%20green%20checkered%20haori%20jacket%20holding%20a%20katana%20in%20a%20dynamic%20pose%2C%20water%20breathing%20effects%20surrounding%20him%2C%20dark%20night%20background%20with%20cherry%20blossom%20petals%2C%20vibrant%20colors%2C%20clean%20illustration%20style%2C%20anime%20poster%20aesthetic&width=600&height=840&seq=anime-cover-01&orientation=portrait',
    description: '炭治郎与伙伴们前往刀匠村，在那里遭遇了上弦之鬼的袭击。在激烈的战斗中，炭治郎的刀被折断，他必须寻找新的力量。与此同时，鬼杀队的柱们开始了严格的训练，为最终决战做准备。',
    tags: ['战斗', '冒险', '奇幻', '热血'],
    featured: true,
  },
  {
    id: 2,
    title: '葬送的芙莉莲',
    slug: 'zangsong-de-fulilian',
    category: 'qihuan',
    rating: 9.8,
    views: '9800万',
    episodes: '28集全',
    status: '已完结',
    year: 2023,
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20illustration%20of%20an%20elf%20mage%20girl%20with%20long%20silver%20white%20hair%20and%20purple%20eyes%20wearing%20a%20white%20robe%20holding%20a%20magical%20staff%2C%20standing%20in%20a%20field%20of%20flowers%20under%20a%20starry%20sky%2C%20gentle%20and%20melancholic%20atmosphere%2C%20soft%20watercolor%20anime%20style&width=600&height=840&seq=anime-cover-02&orientation=portrait',
    description: '打倒魔王的勇者一行人中的魔法使芙莉莲，是寿命悠长的精灵族。在勇者伙伴们相继离世后，她踏上了"了解人类"的旅程。一路上，她遇到了新的伙伴，重新认识了与逝去同伴们共度的时光。',
    tags: ['奇幻', '冒险', '治愈', '成长'],
    featured: true,
  },
  {
    id: 3,
    title: '咒术回战 第二季',
    slug: 'zhoushu-huizhan-di-er-ji',
    category: 'rexue',
    rating: 9.5,
    views: '1.5亿',
    episodes: '23集全',
    status: '已完结',
    year: 2023,
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20anime%20illustration%20of%20a%20white%20haired%20young%20man%20with%20sunglasses%20and%20black%20uniform%20surrounded%20by%20blue%20cursed%20energy%20flames%2C%20intense%20battle%20pose%2C%20urban%20city%20background%20at%20night%2C%20high%20contrast%20lighting%2C%20anime%20action%20poster%20style&width=600&height=840&seq=anime-cover-03&orientation=portrait',
    description: '五条悟与夏油杰的过去被揭开，涉谷事变震撼上演。咒术师与诅咒之间的战斗进入白热化阶段，各方势力的博弈让整个咒术界陷入前所未有的危机。',
    tags: ['战斗', '超能力', '黑暗', '热血'],
    featured: true,
  },
  {
    id: 4,
    title: '辉夜大小姐想让我告白',
    slug: 'huiye-daxiaojie-xiang-rang-wo-gaobai',
    category: 'lianai',
    rating: 9.4,
    views: '8200万',
    episodes: '37集全',
    status: '已完结',
    year: 2022,
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20anime%20illustration%20of%20a%20beautiful%20black%20haired%20schoolgirl%20in%20uniform%20with%20red%20ribbon%20and%20a%20handsome%20blonde%20schoolboy%20standing%20back%20to%20back%20with%20blushing%20expressions%2C%20cherry%20blossom%20petals%20floating%2C%20school%20setting%2C%20bright%20romantic%20atmosphere%2C%20anime%20romantic%20comedy%20style&width=600&height=840&seq=anime-cover-04&orientation=portrait',
    description: '在名门秀知院学园，学生会会长白银御行与副会长四宫辉夜互相暗恋，却因为自尊心都不肯率先告白。两人展开了一场场斗智斗勇的恋爱头脑战，笑料百出又甜蜜温馨。',
    tags: ['恋爱', '校园', '搞笑', '日常'],
    featured: false,
  },
  {
    id: 5,
    title: '夏日重现',
    slug: 'xiari-chongxian',
    category: 'xuanyi',
    rating: 9.3,
    views: '6500万',
    episodes: '25集全',
    status: '已完结',
    year: 2022,
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20anime%20illustration%20of%20a%20boy%20and%20girl%20standing%20on%20a%20sunset%20beach%20looking%20at%20a%20distorted%20shadow%2C%20tropical%20island%20setting%2C%20ominous%20atmosphere%20with%20dark%20clouds%2C%20suspenseful%20thriller%20anime%20aesthetic%2C%20warm%20but%20eerie%20color%20palette&width=600&height=840&seq=anime-cover-05&orientation=portrait',
    description: '网代慎平回到故乡日都岛参加青梅竹马的葬礼，却发现岛上流传着"影子病"的诡异传说。随着调查深入，一个关于时间循环和影子怪物的惊天秘密逐渐浮出水面。',
    tags: ['悬疑', '推理', '超自然', '时间循环'],
    featured: false,
  },
  {
    id: 6,
    title: '间谍过家家',
    slug: 'jiandie-guojiajia',
    category: 'gaoxiao',
    rating: 9.6,
    views: '1.1亿',
    episodes: '37集全',
    status: '连载中',
    year: 2023,
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20and%20heartwarming%20anime%20illustration%20of%20a%20family%20of%20three%20consisting%20of%20a%20man%20in%20suit%2C%20a%20woman%20in%20red%20dress%2C%20and%20a%20little%20pink%20haired%20girl%20with%20a%20dog%2C%20all%20smiling%2C%20living%20room%20setting%2C%20bright%20and%20cozy%20atmosphere%2C%20anime%20family%20comedy%20style&width=600&height=840&seq=anime-cover-06&orientation=portrait',
    description: '为了执行机密任务，顶尖间谍黄昏需要组建一个临时家庭。他领养了能读心的超能力女儿阿尼亚，并与身份神秘的杀手约尔假结婚。这个各怀秘密的虚假家庭，却在相处中产生了真实的羁绊。',
    tags: ['搞笑', '家庭', '间谍', '治愈'],
    featured: true,
  },
  {
    id: 7,
    title: '迷宫饭',
    slug: 'migong-fan',
    category: 'qihuan',
    rating: 9.2,
    views: '5800万',
    episodes: '24集全',
    status: '已完结',
    year: 2024,
    cover: 'https://readdy.ai/api/search-image?query=A%20fun%20fantasy%20anime%20illustration%20of%20a%20group%20of%20adventurers%20cooking%20monsters%20in%20a%20dungeon%2C%20a%20%20dwarf%20chef%20holding%20a%20frying%20pan%2C%20an%20elf%20mage%2C%20and%20a%20human%20warrior%2C%20various%20monster%20ingredients%20on%20a%20table%2C%20dungeon%20stone%20walls%2C%20warm%20campfire%20lighting%2C%20anime%20dungeon%20food%20aesthetic&width=600&height=840&seq=anime-cover-07&orientation=portrait',
    description: '在迷宫深处，冒险者莱欧斯一行遭遇了红龙，妹妹法琳被吞入龙腹。为了在最短时间内救出妹妹，莱欧斯决定不再返回地面补给，而是在迷宫中就地取材——吃掉沿途遇到的魔物！',
    tags: ['奇幻', '美食', '冒险', '搞笑'],
    featured: false,
  },
  {
    id: 8,
    title: '我推的孩子',
    slug: 'wo-tui-de-haizi',
    category: 'xuanyi',
    rating: 9.1,
    views: '7200万',
    episodes: '24集全',
    status: '已完结',
    year: 2023,
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20anime%20illustration%20of%20a%20beautiful%20idol%20girl%20with%20long%20pink%20hair%20and%20star%20shaped%20eyes%20performing%20on%20a%20bright%20stage%20with%20spotlights%2C%20glittering%20stage%20effects%2C%20entertainment%20industry%20setting%2C%20glamorous%20but%20mysterious%20atmosphere%2C%20anime%20showbiz%20drama%20style&width=600&height=840&seq=anime-cover-08&orientation=portrait',
    description: '妇产科医生五郎在推的偶像星野爱即将生子之际遇害，醒来发现自己转生为了星野爱的孩子。以"星野爱久爱海"的身份重生后，他逐渐揭开娱乐圈光鲜表面下的残酷真相。',
    tags: ['悬疑', '偶像', '转生', '娱乐圈'],
    featured: false,
  },
  {
    id: 9,
    title: '摇曳露营△ 第三季',
    slug: 'yaoye-luying-di-san-ji',
    category: 'richang',
    rating: 9.4,
    views: '4200万',
    episodes: '13集全',
    status: '已完结',
    year: 2024,
    cover: 'https://readdy.ai/api/search-image?query=A%20peaceful%20anime%20illustration%20of%20a%20group%20of%20high%20school%20girls%20camping%20by%20a%20beautiful%20lake%20with%20Mount%20Fuji%20in%20the%20background%2C%20sitting%20around%20a%20campfire%2C%20tents%20set%20up%2C%20autumn%20foliage%2C%20cozy%20and%20relaxing%20outdoor%20atmosphere%2C%20anime%20slice%20of%20life%20style&width=600&height=840&seq=anime-cover-09&orientation=portrait',
    description: '热爱露营的少女们再次出发，这次她们将挑战更多美丽的露营地。从春天的樱花营地到秋天的红叶山间，每一个露营地点都充满了温暖与感动，还有让人垂涎的露营美食！',
    tags: ['日常', '治愈', '露营', '美食'],
    featured: false,
  },
  {
    id: 10,
    title: '机动战士高达 水星的魔女',
    slug: 'jidong-zhanshi-gaoda-shuixing-mowu',
    category: 'jizhan',
    rating: 8.9,
    views: '5100万',
    episodes: '24集全',
    status: '已完结',
    year: 2023,
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20anime%20illustration%20of%20a%20giant%20white%20and%20blue%20mecha%20robot%20with%20beam%20saber%20in%20space%20with%20stars%20and%20nebula%20background%2C%20dramatic%20dynamic%20pose%2C%20scifi%20battle%20scene%2C%20anime%20mecha%20poster%20style%20with%20clean%20lines&width=600&height=840&seq=anime-cover-10&orientation=portrait',
    description: '在星际企业支配的世界中，来自水星的少女斯莱塔·墨丘利来到了阿斯提卡西亚高等专门学园。她驾驶着风灵高达，在这个充满阴谋与斗争的世界中寻找属于自己的道路。',
    tags: ['机战', '科幻', '校园', '战斗'],
    featured: false,
  },
  {
    id: 11,
    title: '暗杀教室',
    slug: 'ansha-jiaoshi',
    category: 'gaoxiao',
    rating: 9.3,
    views: '8800万',
    episodes: '47集全',
    status: '已完结',
    year: 2015,
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20anime%20illustration%20of%20a%20yellow%20octopus-like%20creature%20with%20a%20big%20smiley%20face%20wearing%20a%20graduation%20cap%20standing%20in%20a%20classroom%20with%20students%20holding%20toy%20guns%2C%20comedic%20school%20setting%2C%20bright%20colors%2C%20anime%20comedy%20style&width=600&height=840&seq=anime-cover-11&orientation=portrait',
    description: '一个拥有超强力量的黄色章鱼形生物摧毁了月球的70%，并宣布将在一年后毁灭地球。然而，他却主动要求担任椚丘中学3年E班的班主任。学生们必须在一年内暗杀这位"杀老师"来拯救地球。',
    tags: ['搞笑', '校园', '温情', '战斗'],
    featured: false,
  },
  {
    id: 12,
    title: 'Another',
    slug: 'another',
    category: 'kongbu',
    rating: 8.7,
    views: '3900万',
    episodes: '12集全',
    status: '已完结',
    year: 2012,
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20anime%20illustration%20of%20a%20pale%20girl%20with%20an%20eyepatch%20and%20dark%20long%20hair%20standing%20in%20a%20dark%20school%20hallway%2C%20eerie%20atmosphere%2C%20blood%20red%20moon%20through%20window%2C%20shadows%20creeping%2C%20anime%20psychological%20horror%20style&width=600&height=840&seq=anime-cover-12&orientation=portrait',
    description: '转学生榊原恒一来到夜见山北中学后，发现班级笼罩在一种诡异的氛围中。一个名叫见崎鸣的神秘少女引起了所有人的注意——为什么班上的人都假装她不存在？死去的人究竟是谁？',
    tags: ['恐怖', '悬疑', '校园', '诅咒'],
    featured: false,
  },
  {
    id: 13,
    title: 'Re:从零开始的异世界生活',
    slug: 're-cong-ling-kaishi-de-yi-shijie-shenghuo',
    category: 'qihuan',
    rating: 9.5,
    views: '9600万',
    episodes: '50集全',
    status: '连载中',
    year: 2021,
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20anime%20illustration%20of%20a%20boy%20in%20tracksuit%20with%20black%20hair%20holding%20a%20silver%20haired%20half%20elf%20girl%20in%20white%20dress%2C%20magical%20butterflies%20surrounding%20them%2C%20fantasy%20world%20with%20castle%20in%20distance%2C%20dramatic%20and%20emotional%20anime%20art%20style&width=600&height=840&seq=anime-cover-13&orientation=portrait',
    description: '普通高中生菜月昴突然被召唤到异世界，在那里他发现自己拥有"死亡回归"的能力——每次死亡后都会回到一个特定的时间点。为了守护重要的人，他一次次经历死亡，在绝望中寻找希望。',
    tags: ['奇幻', '异世界', '轮回', '冒险'],
    featured: false,
  },
  {
    id: 14,
    title: '紫罗兰永恒花园',
    slug: 'ziluolan-yongheng-huayuan',
    category: 'lianai',
    rating: 9.6,
    views: '5500万',
    episodes: '13集全',
    status: '已完结',
    year: 2018,
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20illustration%20of%20a%20blonde%20girl%20with%20blue%20eyes%20and%20mechanical%20arms%20wearing%20a%20white%20dress%20and%20blue%20jacket%20holding%20a%20letter%2C%20field%20of%20lavender%20flowers%2C%20golden%20sunset%20light%2C%20emotional%20and%20poetic%20atmosphere%2C%20anime%20masterpiece%20style&width=600&height=840&seq=anime-cover-14&orientation=portrait',
    description: '在战争结束后的世界，曾作为兵器存在的少女薇尔莉特，为了理解最重要的人留下的最后一句话"我爱你"的含义，成为了一名"自动手记人偶"，为无法写字的人们代笔写信。',
    tags: ['恋爱', '治愈', '成长', '战争'],
    featured: true,
  },
  {
    id: 15,
    title: '进击的巨人 最终季',
    slug: 'jinji-de-juren-zuizhong-ji',
    category: 'rexue',
    rating: 9.6,
    views: '1.8亿',
    episodes: '28集全',
    status: '已完结',
    year: 2023,
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20anime%20illustration%20of%20a%20giant%20titan%20with%20steam%20rising%20from%20its%20body%20facing%20an%20army%2C%20dark%20apocalyptic%20sky%2C%20destruction%20and%20chaos%2C%20dramatic%20cinematic%20lighting%2C%20anime%20dark%20fantasy%20epic%20style&width=600&height=840&seq=anime-cover-15&orientation=portrait',
    description: '城墙之外的真相被揭开，艾伦做出了改变世界的选择。地鸣启动，无数超大型巨人踏平大地。曾经的伙伴们为了阻止艾伦，展开了一场关乎全人类命运的最终之战。',
    tags: ['战斗', '黑暗', '奇幻', '史诗'],
    featured: true,
  },
  {
    id: 16,
    title: '孤独摇滚!',
    slug: 'gudu-yaogun',
    category: 'richang',
    rating: 9.5,
    views: '6100万',
    episodes: '12集全',
    status: '已完结',
    year: 2022,
    cover: 'https://readdy.ai/api/search-image?query=A%20music%20anime%20illustration%20of%20a%20pink%20haired%20shy%20girl%20holding%20a%20guitar%20in%20a%20closet%2C%20wearing%20a%20tracksuit%2C%20music%20notes%20floating%2C%20warm%20room%20lighting%2C%20slice%20of%20life%20music%20anime%20aesthetic&width=600&height=840&seq=anime-cover-16&orientation=portrait',
    description: '极度社恐的少女后藤一里，在初中时开始学习吉他，梦想着在舞台上闪闪发光。然而三年过去，她依然孤身一人。直到某天，她被一个叫伊地知虹夏的鼓手拉入了名为"纽带乐队"的团体。',
    tags: ['日常', '音乐', '搞笑', '成长'],
    featured: false,
  },
];

export const navLinks = [
  { name: '首页', path: '/' },
  { name: '分类', path: '/category/rexue' },
  { name: '排行', path: '/#ranking' },
  { name: '关于我们', path: '/about' },
];

export const faqList = [
  {
    question: '91动漫是免费的吗？',
    answer: '是的，91动漫平台上的所有番剧均支持免费在线观看。我们致力于为动漫爱好者提供优质、便捷的观番体验，让每一位用户都能畅享正版高清动漫内容。',
  },
  {
    question: '91动漫支持哪些设备观看？',
    answer: '91动漫支持全平台观看，您可以在电脑、平板和手机浏览器上直接访问我们的网站，无需下载任何App。我们采用响应式设计，确保在不同设备上都能获得流畅的观番体验。',
  },
  {
    question: '91动漫的番剧资源是否正版？',
    answer: '91动漫高度重视版权保护，平台上所有动漫资源均获得正版授权。我们与多家国内外知名版权方合作，确保为用户提供合法、高清的动漫内容，让您看得放心。',
  },
  {
    question: '如何获取追番提醒？',
    answer: '您可以在番剧详情页点击"追番"按钮，我们会在该番剧更新时通过站内消息提醒您。同时，首页的"最新更新"板块也会实时展示最新的番剧更新动态。',
  },
  {
    question: '91动漫有哪些动漫类型？',
    answer: '91动漫涵盖热血、恋爱、悬疑、奇幻、搞笑、日常、机战、恐怖等多种类型，满足不同用户的观看偏好。您可以通过分类页面按类型筛选，快速找到感兴趣的番剧。',
  },
  {
    question: '如何联系我们？',
    answer: '您可以通过"关于我们"页面中的联系方式与我们取得联系。我们欢迎用户提供宝贵的意见和建议，帮助我们不断提升服务质量。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '动漫迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20happy%20boy%20with%20short%20black%20hair%2C%20simple%20background%2C%20chibi%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '91动漫的画质真的太棒了！追番体验一流，分类也很清晰，找番超方便。已经成为我的日常必备网站了！',
    rating: 5,
  },
  {
    id: 2,
    name: '追番达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20smiling%20girl%20with%20long%20brown%20hair%2C%20simple%20background%2C%20chibi%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '资源超全，更新速度也很快。以前要到处找资源，现在只需要91动漫一个网站就够了，强烈推荐！',
    rating: 5,
  },
  {
    id: 3,
    name: '资深二次元老王',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20avatar%20of%20a%20cool%20boy%20with%20glasses%20and%20short%20silver%20hair%2C%20simple%20background%2C%20chibi%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '作为一个看了十几年动漫的老宅，91动漫的片库质量和用户体验都是顶级的。分类详细，推荐精准，爱了爱了。',
    rating: 5,
  },
];

export const aboutInfo = {
  brandName: '91动漫',
  slogan: '正版高清动漫在线观看平台',
  introduction: '91动漫成立于2020年，是深受动漫迷喜爱的在线动漫平台。我们始终秉持"让每一位动漫爱好者畅享极致观番体验"的理念，致力于为用户提供海量高清正版动漫资源。',
  mission: '我们的使命是打造国内最优质的动漫内容聚合平台，让优质动漫作品触手可及。未来，91动漫将继续拓展内容库，优化用户体验，成为动漫爱好者最信赖的在线观番平台。',
  stats: [
    { label: '番剧总量', value: '10,000+' },
    { label: '累计用户', value: '500万+' },
    { label: '合作版权方', value: '50+' },
    { label: '日更新番剧', value: '100+' },
  ],
  contact: {
    email: 'contact@91anime.com',
    weibo: '@91动漫官方',
    wechat: '91动漫公众号',
    address: '上海市浦东新区张江高科技园区',
  },
};